import { Provider } from '@angular/core';
import { ErrorHandlingService } from '@errors/error-handling.service';
import { ErrorMessageService } from '@errors/error-message.service';
import { MESSAGE_SERVICE_TOKEN } from '@services/messages';
import { MbmModalMessageService } from './mbm-modal-message.service';
import { MbmModalService } from './mbm-modal.service';

export const MBM_MODAL_PROVIDERS: Provider[] = [
  MbmModalMessageService,
  { provide: MESSAGE_SERVICE_TOKEN, useExisting: MbmModalMessageService },
  ErrorMessageService,
  ErrorHandlingService,
  MbmModalService,
];
